//#region src/dom/store/signal-keys.ts
const signalKeys = { seek: Symbol.for("@videojs/seek") };
//#endregion
export { signalKeys };

//# sourceMappingURL=signal-keys.js.map